import React, { useState } from "react";
import {
  Form,
  Input,
  InputGroup,
  Label,
  Title,
  Timer,
  LabelRequired,
} from "styles/common/FormStyle";
import { ButtonOutline } from "styles/common/ButtonStyle";
import { Background, CommonWrapper } from "styles/common/Layout";
import { sendSMSForSignup, verifySMS } from "api/message";
import { resetPhone } from "api/user";
import useAuthStore from "store/auth";
import { ERROR_CODE_MAP } from "utils/errorHandler";

function ResetPhone() {
  const authStore = useAuthStore();

  const [form, setForm] = useState({
    phoneNumber: "",
    code: "",
    logId: "",
  });

  const [isMessageSent, setIsMessageSent] = useState(false);
  const [isMessageVerified, setIsMessageVerified] = useState(false);
  const [timer, setTimer] = useState(0);

  const isCompleted = Object.values(form).every((value) => value);

  const resetForm = () => {
    setForm({
      phoneNumber: "",
      code: "",
      logId: "",
    });
    setIsMessageSent(false);
    setIsMessageVerified(false);
    setTimer(0);
  };

  const countDown = () => {
    setTimer(180);
    const interval = setInterval(() => {
      setTimer((timer) => timer - 1);
    }, 1000);
    setTimeout(() => {
      clearInterval(interval);
    }, 180000);
  };

  // show seconds as mm:ss
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
  };

  const sendMessage = async () => {
    try {
      await sendSMSForSignup(form.phoneNumber);
      setIsMessageSent(true);
      setIsMessageVerified(false);
      countDown();
      alert("인증번호가 전송되었습니다.");
    } catch (err) {
      alert(err);
    }
  };

  const verifyMessage = async () => {
    try {
      const res = await verifySMS(form.phoneNumber, form.code);
      const logId = res?.data?.logId;
      setForm({ ...form, logId });
      setIsMessageVerified(true);
      alert("인증되었습니다.");
    } catch (err) {
      alert(err);
    }
  };

  const handleChange = (event) => {
    if (event.target.type === "checkbox") {
      setForm({ ...form, [event.target.name]: event.target.checked });
      return;
    }
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const { phoneNumber, logId } = form;

    try {
      await resetPhone({ phoneNumber, logId });
      alert("전화번호가 변경되었습니다.");
      authStore.setUser({ ...authStore.user, telno: phoneNumber });
      resetForm();
    } catch (error) {
      alert(error);
      if (error === ERROR_CODE_MAP[4005]) {
        setIsMessageSent(false);
        setIsMessageVerified(false);
      }
    }
  };

  return (
    <Background>
      <CommonWrapper>
        <Form onSubmit={handleSubmit} id="contents">
          <Title>인증수단 관리</Title>
          <LabelRequired htmlFor="phoneNumber">전화번호</LabelRequired>
          <InputGroup>
            <Input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              value={form.phoneNumber}
              onChange={handleChange}
              placeholder="새로운 전화번호를 입력해주세요."
              disabled={isMessageSent}
            />
            <ButtonOutline
              type="button"
              onClick={sendMessage}
              width="160px"
              height="40px"
              margin="0 0 0 10px"
              disabled={isMessageVerified}
            >
              {isMessageSent ? "재전송" : "인증번호 받기"}
            </ButtonOutline>
          </InputGroup>
          {isMessageSent && (
            <>
              <Label htmlFor="code">인증번호</Label>
              <InputGroup>
                <Input
                  type="text"
                  id="code"
                  name="code"
                  value={form.code}
                  onChange={handleChange}
                  placeholder="인증번호를 입력해주세요."
                  disabled={isMessageVerified}
                />
                {isMessageSent && !isMessageVerified && (
                  <Timer>{formatTime(timer)}</Timer>
                )}
                <ButtonOutline
                  type="button"
                  onClick={verifyMessage}
                  width="120px"
                  height="40px"
                  margin="0 0 0 10px"
                  disabled={isMessageVerified}
                >
                  확인
                </ButtonOutline>
              </InputGroup>
            </>
          )}
          <ButtonOutline
            type="submit"
            margin="0 0 40px 0"
            disabled={!isCompleted}
          >
            변경
          </ButtonOutline>
        </Form>
      </CommonWrapper>
    </Background>
  );
}

export default ResetPhone;
